import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';  
import CircularProgress from '@mui/material/CircularProgress';  // Ajout de l'importation de CircularProgress
import Box from '@mui/material/Box';  // Ajout de l'importation de Box

import Home from './components/Home';
import CommunMenu from './components/CommunMenu'; 
import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
import ProtectedRoute from './ProtectedRoute';
import PaiePage from './components/PaiePage';
// import ActivitiesPage from './components/ActivitiesPage';
// import OperationsPage from './components/OperationsPage';
// import ComptabilitéPage from './components/ComptabilitéPage';
// mport DépensesPage from './components/DépensesPage';
// import Temps from './components/Temps';
import ModiferMotDePassePage from './components/ModiferMotDePassePage';
import ResetPassword from './components/ResetPassword';
import DéclarationsMensuelles from './components/déclarations_mensuelles'; 
import Documents from './components/Documents';
import ListeDeclarations from './components/ListeDeclarations';
import Utilisateurs from './components/Utilisateurs'; // Import du nouveau composant
import Profil from './components/Profil'; // Importer le composant Profil
import FacturePage from './components/FacturePage';
import Déclarations from './components/Déclarations'; 
import AjouterDeclarations from './components/AjouterDeclarations';
import AjouterMaladie from './components/AjouterMaladie';



const App = () => {
  const { isAuthenticated, loading } = useAuth(); // Utilise loading du context



 return (
  
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          {/* Vérifie si l'utilisateur est authentifié pour accéder aux pages protégées */}
          <Route
  path="/"
  element={isAuthenticated ? <Home /> : <Navigate to="/login" />}
/>
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/RegisterForm" element={<ProtectedRoute><RegisterForm /></ProtectedRoute>} />
          <Route path="/Documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
          <Route path="/ModiferMotDePassePage.js" element={<ProtectedRoute><CommunMenu><ModiferMotDePassePage /></CommunMenu></ProtectedRoute>} />
          <Route path="/FacturePage" element={<ProtectedRoute><FacturePage /></ProtectedRoute>} />
          <Route path="/Paie" element={<ProtectedRoute><PaiePage /></ProtectedRoute>} />
          <Route path="/ResetPassword" element={<ResetPassword />} />
          <Route path="/déclarations_mensuelles" element={<ProtectedRoute><DéclarationsMensuelles /></ProtectedRoute>} />
          <Route path="/ListeDeclarations" element={<ProtectedRoute><ListeDeclarations /></ProtectedRoute>} />
          <Route path="/utilisateurs" element={<ProtectedRoute><Utilisateurs /></ProtectedRoute>} />
          <Route path="/profil" element={<ProtectedRoute><Profil /></ProtectedRoute>} />      
          <Route path="/Déclarations" element={<ProtectedRoute><CommunMenu><Déclarations/></CommunMenu></ProtectedRoute>} />   
          <Route path="/Ajouterdeclarations" element={<ProtectedRoute><CommunMenu><AjouterDeclarations/></CommunMenu></ProtectedRoute>} /> 
          <Route path="/AjouterMaladie" element={<ProtectedRoute><CommunMenu><AjouterMaladie/></CommunMenu></ProtectedRoute>} /> 


{/*<Route path="/activities" element={<ProtectedRoute><ActivitiesPage /></ProtectedRoute>} 
<Route path="/operations" element={<ProtectedRoute><OperationsPage /></ProtectedRoute>} />
<Route path="/Comptabilité" element={<ProtectedRoute><ComptabilitéPage /></ProtectedRoute>} />
          <Route path="/Dépenses" element={<ProtectedRoute><DépensesPage /></ProtectedRoute>} />
          <Route path="/Temps" element={<ProtectedRoute><Temps /></ProtectedRoute>} />
/>*/}         
        </Routes>
      </Router>

  );
};

export default App;
